import { render, staticRenderFns } from "./TransferProductType.vue?vue&type=template&id=2e5b1962"
import script from "./TransferProductType.vue?vue&type=script&lang=js"
export * from "./TransferProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports